import attachments from "./attachments";

export default attachments;
